module.exports = __webpack_public_path__ + "img/Hotel Bingo - San Jose.7740f15f.jpeg";